module.exports = __webpack_public_path__ + "img/image_1.531249c6.jpg";